import axios from 'axios'
import errorInterceptor from '@/services/errorInterceptor'
import headerInterceptor from '@/services/headerInterceptor'

const http = axios.create({
  baseURL: import.meta.env.VITE_GRAPHQL_BACKEND_URL,
  withCredentials: true
  // timeout: 30000
})

errorInterceptor(http)
headerInterceptor(http)

export default http
